import { Schematisation } from "@/types/descriptor-types";

import { combineProjectModelExtents, combineRasterExtents } from "./schematisation-extents";

export const getBoundsFromSchematisation = (schematisation: Schematisation | undefined) => {
  if (schematisation?.latest_revision?.threedimodel) {
    return combineProjectModelExtents(schematisation.latest_revision.threedimodel);
  }
  if (schematisation?.latest_revision?.rasters) {
    return combineRasterExtents(schematisation.latest_revision.rasters);
  }
  return null;
};
